// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* JIRA-like Rich Text Editor Styling */

.rich-text-editor {
  border: 1px solid #dfe1e6;
  border-radius: 3px;
  background-color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.rich-text-editor.disabled {
  background-color: #f4f5f7;
  cursor: not-allowed;
}

.menu-bar {
  background-color: #fafbfc;
  border-bottom: 1px solid #dfe1e6;
  padding: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.menu-bar button {
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 3px;
  padding: 6px 10px;
  font-size: 14px;
  cursor: pointer;
  color: #42526e;
  transition: all 0.2s;
  min-width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-bar button:hover {
  background-color: #ebecf0;
  border-color: #dfe1e6;
}

.menu-bar button.is-active {
  background-color: #deebff;
  color: #0052cc;
  border-color: #4c9aff;
}

.menu-bar button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.menu-bar .divider {
  width: 1px;
  height: 24px;
  background-color: #dfe1e6;
  margin: 0 4px;
}

/* Editor Content */
.ProseMirror {
  min-height: 200px;
  padding: 12px 15px;
  outline: none;
  font-size: 14px;
  line-height: 1.6;
  color: #172b4d;
}

.ProseMirror:focus {
  outline: none;
}

.rich-text-editor:focus-within {
  border-color: #4c9aff;
  box-shadow: 0 0 0 1px #4c9aff;
}

.rich-text-editor.disabled:focus-within {
  border-color: #dfe1e6;
  box-shadow: none;
}

/* Placeholder */
.ProseMirror p.is-editor-empty:first-child::before {
  content: attr(data-placeholder);
  float: left;
  color: #999;
  pointer-events: none;
  height: 0;
}

/* Content Styling */
.ProseMirror h1 {
  font-size: 24px;
  font-weight: 600;
  margin: 16px 0 8px;
  color: #172b4d;
}

.ProseMirror h2 {
  font-size: 20px;
  font-weight: 600;
  margin: 14px 0 7px;
  color: #172b4d;
}

.ProseMirror h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 12px 0 6px;
  color: #172b4d;
}

.ProseMirror p {
  margin: 8px 0;
}

.ProseMirror ul,
.ProseMirror ol {
  padding-left: 24px;
  margin: 8px 0;
}

.ProseMirror li {
  margin: 4px 0;
}

.ProseMirror code {
  background-color: #f4f5f7;
  border-radius: 3px;
  padding: 2px 4px;
  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
  font-size: 13px;
  color: #172b4d;
}

.ProseMirror pre {
  background-color: #f4f5f7;
  border-radius: 3px;
  padding: 12px;
  overflow-x: auto;
  margin: 12px 0;
}

.ProseMirror pre code {
  background-color: transparent;
  padding: 0;
}

.ProseMirror blockquote {
  border-left: 3px solid #dfe1e6;
  padding-left: 16px;
  margin: 12px 0;
  color: #6b778c;
}

.ProseMirror a {
  color: #0052cc;
  text-decoration: none;
}

.ProseMirror a:hover {
  text-decoration: underline;
}

.ProseMirror img {
  max-width: 100%;
  height: auto;
  border-radius: 3px;
  margin: 8px 0;
}

.ProseMirror hr {
  border: none;
  border-top: 2px solid #dfe1e6;
  margin: 16px 0;
}

/* Text alignment */
.ProseMirror [style*="text-align: left"] {
  text-align: left;
}

.ProseMirror [style*="text-align: center"] {
  text-align: center;
}

.ProseMirror [style*="text-align: right"] {
  text-align: right;
}

.ProseMirror [style*="text-align: justify"] {
  text-align: justify;
}

/* Strong, emphasis, strikethrough */
.ProseMirror strong {
  font-weight: 600;
}

.ProseMirror em {
  font-style: italic;
}

.ProseMirror s {
  text-decoration: line-through;
}
`, "",{"version":3,"sources":["webpack://./src/components/RichTextEditor.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,iJAAiJ;AACnJ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,+BAA+B;EAC/B,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;EACrD,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":["/* JIRA-like Rich Text Editor Styling */\n\n.rich-text-editor {\n  border: 1px solid #dfe1e6;\n  border-radius: 3px;\n  background-color: #fff;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.rich-text-editor.disabled {\n  background-color: #f4f5f7;\n  cursor: not-allowed;\n}\n\n.menu-bar {\n  background-color: #fafbfc;\n  border-bottom: 1px solid #dfe1e6;\n  padding: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  align-items: center;\n}\n\n.menu-bar button {\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 3px;\n  padding: 6px 10px;\n  font-size: 14px;\n  cursor: pointer;\n  color: #42526e;\n  transition: all 0.2s;\n  min-width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.menu-bar button:hover {\n  background-color: #ebecf0;\n  border-color: #dfe1e6;\n}\n\n.menu-bar button.is-active {\n  background-color: #deebff;\n  color: #0052cc;\n  border-color: #4c9aff;\n}\n\n.menu-bar button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.menu-bar .divider {\n  width: 1px;\n  height: 24px;\n  background-color: #dfe1e6;\n  margin: 0 4px;\n}\n\n/* Editor Content */\n.ProseMirror {\n  min-height: 200px;\n  padding: 12px 15px;\n  outline: none;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #172b4d;\n}\n\n.ProseMirror:focus {\n  outline: none;\n}\n\n.rich-text-editor:focus-within {\n  border-color: #4c9aff;\n  box-shadow: 0 0 0 1px #4c9aff;\n}\n\n.rich-text-editor.disabled:focus-within {\n  border-color: #dfe1e6;\n  box-shadow: none;\n}\n\n/* Placeholder */\n.ProseMirror p.is-editor-empty:first-child::before {\n  content: attr(data-placeholder);\n  float: left;\n  color: #999;\n  pointer-events: none;\n  height: 0;\n}\n\n/* Content Styling */\n.ProseMirror h1 {\n  font-size: 24px;\n  font-weight: 600;\n  margin: 16px 0 8px;\n  color: #172b4d;\n}\n\n.ProseMirror h2 {\n  font-size: 20px;\n  font-weight: 600;\n  margin: 14px 0 7px;\n  color: #172b4d;\n}\n\n.ProseMirror h3 {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 12px 0 6px;\n  color: #172b4d;\n}\n\n.ProseMirror p {\n  margin: 8px 0;\n}\n\n.ProseMirror ul,\n.ProseMirror ol {\n  padding-left: 24px;\n  margin: 8px 0;\n}\n\n.ProseMirror li {\n  margin: 4px 0;\n}\n\n.ProseMirror code {\n  background-color: #f4f5f7;\n  border-radius: 3px;\n  padding: 2px 4px;\n  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;\n  font-size: 13px;\n  color: #172b4d;\n}\n\n.ProseMirror pre {\n  background-color: #f4f5f7;\n  border-radius: 3px;\n  padding: 12px;\n  overflow-x: auto;\n  margin: 12px 0;\n}\n\n.ProseMirror pre code {\n  background-color: transparent;\n  padding: 0;\n}\n\n.ProseMirror blockquote {\n  border-left: 3px solid #dfe1e6;\n  padding-left: 16px;\n  margin: 12px 0;\n  color: #6b778c;\n}\n\n.ProseMirror a {\n  color: #0052cc;\n  text-decoration: none;\n}\n\n.ProseMirror a:hover {\n  text-decoration: underline;\n}\n\n.ProseMirror img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 3px;\n  margin: 8px 0;\n}\n\n.ProseMirror hr {\n  border: none;\n  border-top: 2px solid #dfe1e6;\n  margin: 16px 0;\n}\n\n/* Text alignment */\n.ProseMirror [style*=\"text-align: left\"] {\n  text-align: left;\n}\n\n.ProseMirror [style*=\"text-align: center\"] {\n  text-align: center;\n}\n\n.ProseMirror [style*=\"text-align: right\"] {\n  text-align: right;\n}\n\n.ProseMirror [style*=\"text-align: justify\"] {\n  text-align: justify;\n}\n\n/* Strong, emphasis, strikethrough */\n.ProseMirror strong {\n  font-weight: 600;\n}\n\n.ProseMirror em {\n  font-style: italic;\n}\n\n.ProseMirror s {\n  text-decoration: line-through;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
